<template>
  <div class="content-warpper">
    <div class="warpper-title flex align-center justify-between">
      <div>
        <i class="iconfont iconjigou2"></i>
        {{ id ? "机构编辑" : "机构新增" }}
      </div>
      <type-tab :types="orgForm.type" v-if="!id"/>
    </div>
    <div class="padding-sm">

      <el-form
          :model="orgForm"
          :rules="rules"
          ref="orgForm"
          label-width="140px"
          class="demo-orgForm"
      >
        <h1 class="apply-title">认证培训机构申请表</h1>
        <h3 class="apply-item-title padding-bottom">一、申请单位信息</h3>
        <el-form-item v-if="!id" label="初始密码">
          <el-input
              value="123456"
              disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="申请单位名称" prop="org_name">
          <el-input
              v-model="orgForm.org_name"
              placeholder="请输入申请单位名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="机构组织代码" prop="org_code">
          <el-input
              v-model="orgForm.org_code"
              placeholder="请输入机构组织代码"
          ></el-input>
        </el-form-item>
        <el-form-item label="营业执照" prop="org_license">
          <el-upload
              class="avatar-uploader"
              :action="upUrl + '/admin/upload'"
              :name="'image'"
              :data="fileData"
              :show-file-list="false"
              accept="image/*"
              :on-success="handleAvatarSuccess"
          >
            <img v-if="orgForm.org_license" :src="imgUrl + orgForm.org_license" class="avatar"/>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="联系人姓名" prop="username">
          <el-input
              v-model="orgForm.username"
              placeholder="请输入联系人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人职务" prop="zhiwu">
          <el-input
              v-model="orgForm.zhiwu"
              placeholder="请输入联系人职务"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人手机号" prop="phone">
          <el-input
              v-model="orgForm.phone"
              placeholder="请输入联系人手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人邮箱" prop="email">
          <el-input
              v-model="orgForm.email"
              placeholder="请输入联系人邮箱"
          ></el-input>
        </el-form-item>
        <el-form-item label="机构所在地" prop="region_text">
          <el-cascader
              style="width: 100%;"
              expand-trigger="hover"
              filterable
              placeholder="请选择机构所在地"
              :options="options"
              v-model="orgForm.region_text"
              @change="addressChange"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input
              v-model="orgForm.address"
              placeholder="请输入详细地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="申请单位地理位置">
          <div class="flex align-center justify-between">
            <el-button type="primary" plain @click="showMap = !showMap" v-show="!showMap">获取地址</el-button>
            <el-autocomplete v-show="showMap"
                             v-model="point"
                             style="width:100%;"
                             popper-class="autoAddressClass"
                             :fetch-suggestions="querySearchAsync"
                             :trigger-on-focus="false"
                             placeholder="请输入详细地址"
                             clearable
                             @select="handleSelect"
            >
              <template slot-scope="{ item }">
                <i class="el-icon-search fl mgr10"/>
                <div style="overflow:hidden;">
                  <div class="title">{{ item.title }}</div>
                  <span class="address ellipsis">{{ item.address }}</span>
                </div>
              </template>
            </el-autocomplete>
            <div v-show="showMap" class="margin-lr">
              {{ orgForm.addrPoint.lng | fixeds }},{{ orgForm.addrPoint.lat | fixeds }}
            </div>
            <el-button type="info" plain v-show="showMap" @click="resetAddress">地址重置</el-button>
          </div>
        </el-form-item>
        <el-form-item v-show="showMap">
          <div id="map-container" style="width:100%;height:300px;"/>
        </el-form-item>
        <!--        <el-form-item label-width="50px" label=" " prop="way">-->
        <!--          <p>请提供到达您机构位置的公共交通方式及路线，包括公交、地铁线路，具体哪路公交车，哪条地铁，在哪一站出站</p>-->
        <!--          <el-input-->
        <!--              v-model="orgForm.way"-->
        <!--              placeholder="请输入"-->
        <!--              type="textarea"-->
        <!--              rows="3"-->
        <!--          ></el-input>-->
        <!--        </el-form-item>-->
        <!--        <h3 class="apply-item-title padding-top padding-bottom-xs">二、申请单位生源信息</h3>-->
        <!--        <el-form-item label-width="50px" label=" " prop="shengyuan">-->
        <!--          <p>请详细说明生源来源 诸如：生源来源地、生源行业背景、生源质量（如：学历、从业领域和年限等）、参加研学旅行指导师考试意愿等。</p>-->
        <!--          <el-input-->
        <!--              v-model="orgForm.shengyuan"-->
        <!--              placeholder="请输入"-->
        <!--              type="textarea"-->
        <!--              rows="3"-->
        <!--          ></el-input>-->
        <!--        </el-form-item>-->
        <!--        <h3 class="apply-item-title padding-top padding-bottom-xs">三、申请单位师资信息</h3>-->
        <!--        <el-form-item label-width="50px" label=" " prop="shizi">-->
        <!--          <p>请说明贵机构师资情况 诸如：师资人数、专业背景、有无研学旅行工作经验、有无研学旅行授课经验等。</p>-->
        <!--          <el-input-->
        <!--              v-model="orgForm.shizi"-->
        <!--              placeholder="请输入"-->
        <!--              type="textarea"-->
        <!--              rows="3"-->
        <!--          ></el-input>-->
        <!--        </el-form-item>-->
        <!--        <h3 class="apply-item-title padding-top padding-bottom-xs">四、申请单位课程信息</h3>-->
        <!--        <el-form-item label-width="50px" label=" " prop="kecheng">-->
        <!--          <p>请详细说明培训课程情况 诸如：申请单位研学旅行课程特色、课时、教材、教学方法、评价方法，课程从何时开始对外招生、各期招生情况、学生反馈、毕业后学生在研学旅行行业从业状况等。</p>-->
        <!--          <el-input-->
        <!--              v-model="orgForm.kecheng"-->
        <!--              placeholder="请输入"-->
        <!--              type="textarea"-->
        <!--              rows="3"-->
        <!--          ></el-input>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label-width="50px" label=" " prop="kecheng_file">-->
        <!--          <p>其他附加材料及文档</p>-->
        <!--          <up-file :name="'kecheng_file'" @fileSuccess="fileSuccess" @fileDelete="fileDelete" :fileName="orgForm.kecheng_file"/>-->
        <!--        </el-form-item>-->
        <!--        <h3 class="apply-item-title padding-top padding-bottom-xs">五、申请单位取得认证后招生计划</h3>-->
        <!--        <el-form-item label-width="50px" label=" " prop="zhaosheng">-->
        <!--          <p>请说明取得认证后的招生计划人数</p>-->
        <!--          <el-input-->
        <!--              type="number"-->
        <!--              v-model.number="orgForm.zhaosheng"-->
        <!--              placeholder="请输入取得认证后的招生计划人数"-->
        <!--          ></el-input>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label-width="50px" label=" " prop="renshu">-->
        <!--          <p>请说明取得认证后的报考人数</p>-->
        <!--          <el-input-->
        <!--              type="number"-->
        <!--              v-model.number="orgForm.renshu"-->
        <!--              placeholder="请输入取得认证后的报考人数"-->
        <!--          ></el-input>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label-width="50px" label=" " prop="zhaosheng_file">-->
        <!--          <p>其他附加材料及文档</p>-->
        <!--          <up-file :name="'zhaosheng_file'" @fileSuccess="fileSuccess" @fileDelete="fileDelete" :fileName="orgForm.zhaosheng_file"/>-->
        <!--        </el-form-item>-->
        <h3 class="apply-item-title padding-top padding-bottom-xs">六、其他设置</h3>
        <el-form-item label="隶属协调中心 " prop="xtzx_id">
          <el-select v-model="orgForm.xtzx_id" filterable placeholder="请选择隶属协调中心(需先选择机构所在地)"
                     style="width: 100%;">
            <el-option
                v-for="item in parentTypes"
                :key="item.type"
                :label="item.name"
                :value="item.type">
            </el-option>
          </el-select>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="到期时间类型" prop="resource">
              <el-radio-group v-model="orgForm.resource">
                <el-radio label="1">默认到期时间</el-radio>
                <el-radio label="2">自定义到期时间</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="到期时间 " prop="due_date" v-if="!id && Number(orgForm.resource) === 2 ">
              <el-date-picker
                  style="width: 100%;"
                  v-model="orgForm.due_date"
                  align="right"
                  type="date"
                  placeholder="请选择到期时间"
                  :picker-options="pickerOptions1">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>


        <el-form-item label="备注信息" prop="remark">
          <el-input
              type="textarea"
              v-model="orgForm.remark"
              placeholder="请输入备注信息"
              rows="3"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
              type="primary"
              class="submit-btn"
              @click="submitForm('orgForm')"
          >提交
          </el-button
          >
          <el-button class="submit-btn" @click="back">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {dueDate} from "@/tools/utils";
import loadBMap from "@/tools/utils";
import {UPFILE, IMGURL} from "@/config/index";
import {regionData} from "element-china-area-data";
import {orgAddCr2, orgGetXietiao, orgOne} from "@/api/projectOffice";
// import upFile from "@/components/upFile";
import typeTab from "@/views/projectOffice/page/conponents/typeTab";
// CodeToText
export default {
  name: "organizationAdd",
  components: {
    typeTab,
    // upFile
  },
  data() {
    // 手机号验证
    var checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[0-9]{10}$/;
      if (!value) {
        return callback(new Error("手机号码不能为空"));
      }
      setTimeout(() => {
        if (!Number.isInteger(+value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (phoneReg.test(value)) {
            callback();
          } else {
            callback(new Error("手机号码格式不正确"));
          }
        }
      }, 100);
    };

    return {
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        }
      },
      id: '',
      dueDate: dueDate(),
      parentTypes: [],
      options: regionData,
      map: "", //地图实例
      mk: "", //Marker实例
      locationPoint: null,
      showMap: false,
      point: '',
      orgForm: {
        type: 2,
        org_name: "",
        org_code: "",
        org_license: "",
        username: "",
        zhiwu: "",
        phone: "",
        email: "",
        region_text: "",
        address: "",
        addrPoint: {
          lng: 0,
          lat: 0
        },
        way: '',
        shengyuan: '',
        shizi: '',
        kecheng: '',
        kecheng_file: '',
        zhaosheng: '',
        renshu: '',
        zhaosheng_file: '',
        xtzx_id: '',
        resource:'1',
        due_date: '',
        remark: '',
      },
      rules: {
        org_name: [{required: true, message: "请输入申请单位名称", trigger: "blur"}],
        org_code: [{required: true, message: "请输入机构组织代码", trigger: "blur"}],
        org_license: [{required: true, message: "请上传营业执照", trigger: "change"}],
        username: [{required: true, message: "请输入联系人姓名", trigger: "blur"}],
        zhiwu: [{required: true, message: "请输入联系人职务", trigger: "blur"}],
        phone: [{required: true, validator: checkPhone, trigger: "blur"}],
        email: [{required: true, message: "请输入邮箱地址", trigger: "blur"},
          {type: "email", message: "请输入正确的邮箱地址", trigger: "blur"}],
        region_text: [{required: true, message: "请选择机构所在地", trigger: "change"}],
        address: [{required: true, message: "请输入详细地址", trigger: "blur"}],
        // way: [{required: true, message: "请提供到达您机构位置的公共交通方式及路线", trigger: "blur"}],
        // shengyuan: [{required: true, message: "请详细说明生源来源", trigger: "blur"}],
        // shizi: [{required: true, message: "请说明贵机构师资情况", trigger: "blur"}],
        // kecheng: [{required: true, message: "请详细说明培训课程情况", trigger: "blur"}],
        // kecheng_file: [{required: true, message: "请上传申请单位课程信息其他附加材料及文档", trigger: "change"}],
        // zhaosheng: [{required: true, message: "请说明取得认证后的招生计划", trigger: "blur"}],
        // renshu: [{required: true, message: "请说明取得认证后的报考人数", trigger: "blur"},
        //   {type: 'number',min: 1, message: "取得认证后的报考人数需大于0", trigger: "blur"}],
        // zhaosheng_file: [{required: true, message: "请上传申请单位取得认证后招生计划其他附加材料及文档", trigger: "change"}],
        xtzx_id: [{required: true, message: "请选择隶属协调中心", trigger: "change"}],
        resource: [{required: true, message: "请选择到期时间类型", trigger: "change"}],
        due_date: [{type: 'date',required: true, message: "请选择到期时间", trigger: "change"}],
      }
    };
  },
  computed: {
    fileData() {
      return {
        u_token: this.$store.state.token2
      };
    },
    upUrl() {
      return UPFILE
    },
    imgUrl() {
      return IMGURL
    }
  },
  created() {
    this.id = this.$route.query.id ? this.$route.query.id : '';
    if (this.$route.query.type) this.orgForm.type = Number(this.$route.query.type)
    this.$emit(
        "setIndex",
        "/projectOffice/organization",
        "当前位置：机构管理 > <span>" +
        (this.id ? "机构编辑" : "机构新增") +
        "</span> ",
        true
    );
    if (this.id) this.getDetail()
    this.getLsxtList()
  },
  async mounted() {
    await loadBMap("McBWgFElxpnhhnO5kHHthQyG2KRsHLZS"); //加载引入BMap
    // this.initMap();
  },
  methods: {

    async getDetail() {
      let _data = await orgOne(this.id, this.orgForm.type)

      this.orgForm = {
        type: 2,
        org_name: _data.data.org_name,
        org_code: _data.data.org_code,
        org_license: _data.data.org_license,
        username: _data.data.username,
        zhiwu: _data.data.zhiwu,
        phone: _data.data.phone,
        email: _data.data.email,
        region_text: _data.data.region_text.split(','),
        address: _data.data.address,
        addrPoint: {
          lng: Number(_data.data.longitude),
          lat: Number(_data.data.latitude)
        },
        // way:_data.data.way,
        // shengyuan:_data.data.shengyuan,
        // shizi:_data.data.shizi,
        // kecheng:_data.data.kecheng,
        // kecheng_file:_data.data.kecheng_file,
        // zhaosheng:_data.data.zhaosheng,
        // renshu:_data.data.renshu,
        // zhaosheng_file:_data.data.zhaosheng_file,
        xtzx_id: _data.data.xtzx_id,
        due_date: new Date(_data.data.due_date),
        remark: _data.data.remark,
      }
      if (Number(_data.data.longitude)) {
        this.showMap = true
        setTimeout(() => {
          var point = new BMap.Point(_data.data.longitude, _data.data.latitude);
          this.map.clearOverlays();
          this.mk = new BMap.Marker(point);
          this.map.addOverlay(this.mk);
          this.map.panTo(point);
          this.orgForm.addrPoint = {
            lng: Number(_data.data.longitude),
            lat: Number(_data.data.latitude)
          }
        }, 400)
      }
      this.getLsxtList()
    },
    handleAvatarSuccess(res) {
      if (res.code === 1002) {
        this.orgForm.org_license = res.data.path
        this.$refs.orgForm.validateField('org_license')
      } else {
        this.$message.error(res.data)
      }
    },

    addressChange(arr) {
      this.orgForm.region = arr;
    },

    //  获取隶属协调中心
    async getLsxtList() {
      let _data = await orgGetXietiao(
          '',
          this.orgForm.region_text ? this.orgForm.region_text.join(',') : '',
          this.orgForm.type)
      let arr = []
      _data.data.map(item => {
        arr.push({
          type: item.org_id,
          name: item.org_name
        })
      })
      this.parentTypes = arr
    },


    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitOrg()
        }else{
          this.$message.error('信息未填写完整，请检查确认')
        }
      });
    },
    async submitOrg() {
      let _date = Number(this.orgForm.resource) === 1 ? '' : this.$tools.ZHDate(new Date(this.orgForm.due_date))
      let _state = await orgAddCr2(
          this.orgForm.org_name,
          this.orgForm.org_code,
          this.orgForm.org_license,
          this.orgForm.username,
          this.orgForm.zhiwu,
          this.orgForm.phone,
          this.orgForm.email,
          this.orgForm.region_text.join(','),
          this.orgForm.address,
          this.orgForm.addrPoint.lng,
          this.orgForm.addrPoint.lat,
          // this.orgForm.way,
          // this.orgForm.shengyuan,
          // this.orgForm.shizi,
          // this.orgForm.kecheng,
          // this.orgForm.kecheng_file,
          // this.orgForm.zhaosheng,
          // this.orgForm.renshu,
          // this.orgForm.zhaosheng_file,
          this.orgForm.xtzx_id,
          _date,
          this.orgForm.remark,
          this.id
      )
      this.$message.success(_state.msg)
      this.$router.go(-1)
    },

    //  上传文件
    fileSuccess(val) {
      this.orgForm[val.name] = val.src
    },
    fileDelete(val) {
      this.orgForm[val] = ''
    },

    //  地图部分
    initMap() {
      var that = this;
      // 1、挂载地图
      this.map = new BMap.Map("map-container", {enableMapClick: false});
      var point = new BMap.Point(116.403963, 39.913261);
      this.map.centerAndZoom(point, 16);
      // this.map.enableScrollWheelZoom(true);
      setTimeout(() => {
        this.resetAddress()
      }, 200)

      // 3、设置图像标注并绑定拖拽标注结束后事件
      // this.mk = new BMap.Marker(point, {enableDragging: true});
      // this.map.addOverlay(this.mk);
      // this.mk.addEventListener("dragend", function (e) {
      //   that.getAddrByPoint(e.point);
      // });
      // 4、添加（右上角）平移缩放控件
      this.map.addControl(
          new BMap.NavigationControl({
            anchor: BMAP_ANCHOR_TOP_RIGHT,
            type: BMAP_NAVIGATION_CONTROL_SMALL
          })
      );
      // 5、添加（左下角）定位控件
      var geolocationControl = new BMap.GeolocationControl({
        anchor: BMAP_ANCHOR_BOTTOM_LEFT
      });
      geolocationControl.addEventListener("locationSuccess", function (e) {
        that.getAddrByPoint(e.point);
      });
      geolocationControl.addEventListener("locationError", function (e) {
        alert(e.message);
      });
      this.map.addControl(geolocationControl);
    },
    // 获取两点间的距离
    getDistancs(pointA, pointB) {
      return this.map.getDistance(pointA, pointB).toFixed(2);
    },
    // 浏览器定位函数
    geolocation() {
      var that = this;
      var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(
          function (res) {
            if (this.getStatus() == BMAP_STATUS_SUCCESS) {
              that.getAddrByPoint(res.point);
              that.locationPoint = res.point;
            } else {
              alert("failed" + this.getStatus());
              that.locationPoint = new BMap.Point(113.3324436, 23.1315381);
            }
          },
          {enableHighAccuracy: true}
      );
    },
    // 逆地址解析函数
    getAddrByPoint(point) {
      var that = this;
      var geco = new BMap.Geocoder();
      geco.getLocation(point, function (res) {
        that.mk.setPosition(point);
        that.map.panTo(point);
        that.orgForm.address = res.address;
        that.orgForm.addrPoint = point;
      });
    },
    // 地址搜索
    querySearchAsync(str, cb) {
      var options = {
        onSearchComplete: function (res) {
          var s = [];
          if (local.getStatus() == BMAP_STATUS_SUCCESS) {
            for (var i = 0; i < res.getCurrentNumPois(); i++) {
              s.push(res.getPoi(i));
            }
            console.log(s);
            cb(s);
          } else {
            cb(s);
          }
        }
      };
      var local = new BMap.LocalSearch(this.map, options);
      local.search(str);
    },
    // 选择地址
    handleSelect(item) {
      this.point = item.address + item.title;
      this.orgForm.addrPoint = item.point;
      this.map.clearOverlays();
      this.mk = new BMap.Marker(item.point);
      this.map.addOverlay(this.mk);
      this.map.panTo(item.point);
    },
    // 地址重置
    resetAddress() {
      var point = new BMap.Point(116.403962, 39.915119);
      this.map.clearOverlays();
      this.map.centerAndZoom(point, 16);
      this.point = ''
      this.orgForm.addrPoint.lng = 0
      this.orgForm.addrPoint.lat = 0
      // this.mk = new BMap.Marker(point);
      // this.map.addOverlay(this.mk);
      // this.map.panTo(point);
    },
    back() {
      this.$router.go(-1);
    }
  },
  watch: {
    showMap() {
      this.initMap();
    },
    //  监听所在地变化后 隶属协调中心发生变化
    'orgForm.region_text'() {
      this.orgForm.parent_id = ''
      this.getLsxtList()
    },
  },
  filters: {
    fixeds(val) {
      return val.toFixed(6)
    }
  }
};
</script>

<style scoped lang="scss">
.content-warpper {
  .apply-title {
    text-align: center;
    font-size: 32px;
    color: #009688;
    padding: 30px 30px 50px;
  }

  .apply-item-title {
    font-size: 18px;
  }
}

.autoAddressClass {
  li {
    i.el-icon-search {
      margin-top: 11px;
    }

    .mgr10 {
      margin-right: 10px;
    }

    .title {
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .address {
      line-height: 1;
      font-size: 12px;
      color: #b4b4b4;
      margin-bottom: 5px;
    }
  }
}
</style>
